import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Demo.css';

const Demo: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="demo-container">
      <div className="hero">
        <h1>{t('demo.title')}</h1>
        <p>{t('demo.subtitle')}</p>
      </div>

      <div className="features-grid">
        <div className="feature-card">
          <h3>🎪 {t('demo.eventManager')}</h3>
          <p>{t('demo.eventManagerDesc')}</p>
          <Link to="/manager" className="btn btn-primary">{t('demo.openEventManager')}</Link>
        </div>

        <div className="feature-card">
          <h3>🎫 {t('demo.advancedTicketPurchase')}</h3>
          <p>{t('demo.advancedTicketPurchaseDesc')}</p>
          <Link to="/purchase/demo-event" className="btn btn-primary">{t('demo.viewTicketPurchase')}</Link>
        </div>

        <div className="feature-card">
          <h3>📋 {t('demo.eventList')}</h3>
          <p>{t('demo.eventListDesc')}</p>
          <Link to="/events" className="btn btn-secondary">{t('demo.viewEvents')}</Link>
        </div>

        <div className="feature-card">
          <h3>🔧 {t('demo.legacyComponents')}</h3>
          <p>{t('demo.legacyComponentsDesc')}</p>
          <Link to="/admin" className="btn btn-secondary">{t('demo.adminDashboard')}</Link>
        </div>
      </div>

      <div className="api-info">
        <h2>{t('demo.apiInformation')}</h2>
        <div className="info-box">
          <h4>{t('demo.lambdaApiEndpoint')}:</h4>
          <code>https://54v0v1tgji.execute-api.eu-west-2.amazonaws.com/prod/</code>
          
          <h4>{t('demo.featuresImplemented')}:</h4>
          <ul>
            <li>✅ {t('demo.eventCrud')}</li>
            <li>✅ {t('demo.multiCategoryTicketing')}</li>
            <li>✅ {t('demo.ageValidation')}</li>
            <li>✅ {t('demo.voucherSupport')}</li>
            <li>✅ {t('demo.paymentProcessing')}</li>
            <li>✅ {t('demo.geolocationMedia')}</li>
            <li>✅ {t('demo.ticketValidation')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Demo;
